import React, { memo } from 'react';
import Grid from '../Utils/Grid/Grid';
import Col from '../Utils/Col/Col';
import ArticleIndexPageResultLoadingCard from '../ArticleIndexPage/ArticleIndexPageResultLoadingCard';

const FlatArticleIndexPageLoading: React.FC = () => {
    return (
        <div className="space-y-10 md:space-y-16 lg:space-y-20">
            {/*-- top row --*/}
            <Grid>
                {[1,2].map((loadingId: number) => (
                    <Col key={`top-row-loading-card--${loadingId}`} span={{ md: 6 }}>
                        <ArticleIndexPageResultLoadingCard />
                    </Col>
                ))}
            </Grid>

            {/*-- bottom row --*/}
            <Grid>
                {[1,2,3].map((loadingId: number) => (
                    <Col key={`bottom-row-loading-card--${loadingId}`} span={{ md: 4 }}>
                        <ArticleIndexPageResultLoadingCard />
                    </Col>
                ))}
            </Grid>
        </div>
    )
}

export default memo(FlatArticleIndexPageLoading);